import { render } from "./DataBoxes.vue?vue&type=template&id=4da1a278"
import script from "./DataBoxes.vue?vue&type=script&lang=js"
export * from "./DataBoxes.vue?vue&type=script&lang=js"
script.render = render

export default script